<template>
<div v-if="!isPageLoading">
    <v-card v-if="hasAdminAccess && (user != null || currentuser != null)">
        <v-card-title v-show="!isLoggedInUserActive">
            <label style="color: red">{{ $t("msguserisnotactive") }}</label>
        </v-card-title>
        <v-data-table :headers="headers" :items="plantUsers" :search="search" v-show="isLoggedInUserActive" :footer-props="{
          itemsPerPageOptions: tableItemsPerPage,
          itemsPerPageText: rowsperpage,
        }" :options="options">
            <template v-slot:top>
                <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card light flat>
                        <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-progress-circular indeterminate color="primary" v-show="deleteinProgress"></v-progress-circular>
                            <v-btn color="blue darken-1" text @click="closeDelete" v-show="!deleteinProgress">Close</v-btn>
                            <v-btn color="blue darken-1" text @click="deleteItemConfirm" v-show="!deleteinProgress">OK</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-toolbar flat dense>
                    <h3>{{ $t("users") }}</h3>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-btn color="primary" dark class="mb-2" @click.stop="openNewUser()">
                        {{ $t("new") }}
                    </v-btn>
                    <v-dialog v-model="dialog" max-width="500px">

                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                                <v-spacer></v-spacer>
                                <v-icon @click="close(1)">close</v-icon>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="8" md="8" v-if="!isEditUser">
                                            <v-autocomplete v-model="model" :items="items" :loading="isLoading" :search-input.sync="searchapi" color="black" hide-no-data hide-selected item-text="givenName" item-value="email" v-bind:placeholder="$t('searchuser') + ' *'" prepend-icon="mdi-account-search" style="background-color: #ffffcc" clearable @click:clear="model = null" return-object></v-autocomplete>
                                            <div v-if="model">
                                                <div v-if="isAzureDeployed==1" class="red lighten-3">
                                                    {{fields[4].value}}
                                                </div>
                                                <div v-else class="red lighten-3">
                                                    {{fields[0].value}}
                                                </div>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" sm="8" md="8" v-else>
                                            User Info:
                                            <h3>{{ searchUser }}</h3>
                                            <div class="red lighten-3">
                                                {{ addUserEmail }}
                                            </div>
                                        </v-col>
                                        <v-col cols="12" sm="8" md="8">
                                            <v-select style="background-color: #ffffcc" :items="plants" v-bind:label="$t('plant') + ' *'" v-model="selecttedplant" item-text="plant" item-value="id" @change="changePlant">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" sm="8" md="8">
                                            <v-select style="background-color: #ffffcc" :items="companies" v-bind:label="$t('company') + ' *'" v-model="selectedcontractor" item-text="value" item-value="id" :readonly="companyreadOnly">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" sm="8" md="8">
                                            <v-radio-group row v-model="isUserActive" style="background-color: #ffffcc">
                                                <v-radio v-bind:label="$t('active')" value="Y"></v-radio>
                                                <v-radio v-bind:label="$t('notactive')" value="N"></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                        <v-col cols="12" sm="8" md="8">
                                            <v-select style="background-color: #ffffcc" :items="languages" v-bind:label="$t('language') + ' *'" v-model="selectedlanguage" item-text="language" item-value="id">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-text-field v-model="editedItem.otherInfo" v-bind:label="$t('otherinfo')"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn color="blue darken-1" text @click="close(1)">{{
                    $t("cancel")
                  }}</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" dark class="mb-2" @click="save">{{
                    $t("save")
                  }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-text-field v-model="search" append-icon="mdi-magnify" v-bind:label="$t('searchall')" single-line hide-details></v-text-field>
                </v-toolbar>
            </template>
            <template v-slot:[`item.action`]="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">
                    mdi-pencil
                </v-icon>
                <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="getUserHCFromAPI">Reset</v-btn>
            </template>
        </v-data-table>
    </v-card>
    <v-alert v-else-if="user != null || currentuser != null" outlined type="warning" prominent border="left">
        {{ $t("accessdenied") }}
    </v-alert>
</div>
<div v-else>
    <v-progress-linear indeterminate color="teal" rounded height="8"></v-progress-linear>
</div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import i18n from "@/plugins/i18n";
import requestsMixin from "@/mixins/requests"
export default {
    mixins: [requestsMixin],
    data() {
        return {
            isAzureDeployed: process.env.AZURE_DEPLOYED,
            search: "",
            users: [],
            allplants: [],
            plants: [],
            companies: [],
            allcompanies: [],
            languages: [],
            OADUsers: [],
            selectedOADUser: -1,
            dialog: false,
            statusmessages: [],
            isSucess: false,
            editedIndex: -1,
            selecttedplant: -1,
            selectedcontractor: -1,
            selectedlanguage: 1,
            isUserActive: "Y",
            companyreadOnly: false,
            isAllOADUsersLoaded: false,
            editedItem: {
                id: 0,
                plant: "",
                company: "",
                language: "",
                otherInfo: "",
                userName: "",
                userEmail: "",
                createdBy: "",
                createdOn: "",
                previousPlant: "",
                previousCompany: "",
                isActive: "",
            },
            defaultItem: {
                id: 0,
                plant: "",
                company: "",
                language: "",
                otherInfo: "",
                userName: "",
                userEmail: "",
                createdBy: "",
                createdOn: "",
                previousPlant: "",
                previousCompany: "",
                isActive: "",
            },
            date: new Date().toISOString().substr(0, 10),
            dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
            searchUser: "",
            entries: [],
            plantUsers: [],
            useraccess: [],
            currentuser: [],
            addUserEmail: null,
            emailreadOnly: false,
            user: null,
            queryTerm: "",
            isPageLoading: true,
            vSelUser: {},
            disInput: false,
            descriptionLimit: 60,
            entries: [],
            isLoading: false,
            model: null,
            searchapi: null,
            isEditUser: false,
            tableItemsPerPage: [25, 50, 100, -1],
            options: null,
            deleteinProgress: false,
            dialogDelete: false,
        };
    },
    mounted() {
        this.getLanguages();
    },
    methods: {
        getUserHCFromAPI() {
            var self = this;
            self.isPageLoading = true;
            if (self.$store.state.userDetails != null) {
                self.getUser();
            } else {
                self.user = self.$store.state.userDetails;
                self.helperUserHCFromAPI();
            }
        },
        helperUserHCFromAPI() {
            var self = this;
            self.users = [];
            self.plantUsers = [];
            const link = window.apiurl + "/userheadcount";
            axios
                .get(link, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.users = response.data;
                    var object = [];
                    var object1 = [];
                    object = self.users.filter(
                        (x) =>
                        x.userEmail.toLowerCase() == self.user.userEmail.toLowerCase() &&
                        x.plant == "Global" &&
                        x.isActive == "Y"
                    );
                    object1 = self.users.filter(
                        (x) =>
                        x.userEmail.toLowerCase() == self.user.userEmail.toLowerCase() &&
                        x.company == "LYB" &&
                        x.isActive == "Y"
                    );
                    var index = 0;
                    if (object != null && object.length > 0) {
                        var index1 = 0;
                        for (index1 = 0; index1 < self.users.length; index1++) {
                            var languagetext = self.languages.find(
                                (x) => x.id == self.users[index1].language
                            ).language;
                            self.users[index1].language = languagetext;
                            self.plantUsers.push(self.users[index1]);
                        }
                    } else if (object1 != null && object1.length > 0) {
                        var filterPlants = [];
                        filterPlants = self.users.filter(
                            (x) =>
                            x.userEmail == self.user.userEmail &&
                            x.company == "LYB" &&
                            x.isActive == "Y"
                        );
                        index = 0;
                        for (index = 0; index < filterPlants.length; index++) {
                            var filterPlantUsers = [];
                            filterPlantUsers = self.users.filter(
                                (x) =>
                                x.plant.trim().toLowerCase() ==
                                filterPlants[index].plant.trim().toLowerCase()
                            );
                            var object2 = [];
                            object2 = self.plantUsers.filter(
                                (x) => x.plant == filterPlants[index].plant
                            );
                            if (
                                filterPlantUsers.length > 0 &&
                                (object2 == null || object2.length == 0)
                            ) {
                                var index1 = 0;
                                for (index1 = 0; index1 < filterPlantUsers.length; index1++) {
                                    var languagetext = self.languages.find(
                                        (x) => x.id == filterPlantUsers[index1].language
                                    ).language;
                                    filterPlantUsers[index1].language = languagetext;
                                    self.plantUsers.push(filterPlantUsers[index1]);
                                }
                            }
                        }
                    }

                    self.getPlants();
                })
                .catch((error) => console.log(error));

            const link1 = window.apiurl + "/contractorcompany";
            axios
                .get(link1, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.allcompanies = response.data;
                })
                .catch((error) => console.log(error));

            const link4 =
                window.apiurl + "/userheadcount/myview/" + self.user.userEmail;
            axios
                .get(link4, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.useraccess = response.data;
                    i18n.locale = self.useraccess[0].language;
                    if (self.useraccess[0].rowsPerPage != null) {
                        var rowsPrPg =
                            self.useraccess[0].rowsPerPage == "All" ?
                            -1 :
                            parseInt(self.useraccess[0].rowsPerPage);
                        self.options = {
                            itemsPerPage: rowsPrPg,
                        };
                    } else {
                        self.options = {
                            itemsPerPage: 25,
                        };
                    }
                    self.isPageLoading = false;
                })
                .catch((error) => console.log(error));
        },
        getLanguages() {
            var self = this;
            //self.searchtest()
            const link =
                window.apiurl + "/MppiContractorLanguageMasters/GetSavedLanguages";
            axios
                .get(link, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.languages = response.data;
                })
                .then(() => {
                    self.getUserHCFromAPI();
                })
                .catch((error) => console.log(error));
        },
        getPlants() {
            var self = this;
            self.plants = [];
            const link2 = window.apiurl + "/plants";
            axios
                .get(link2, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.allplants = response.data;
                    var filterPlantUser = [];
                    filterPlantUser = self.plantUsers.filter((x) => x.plant == "Global");
                    if (filterPlantUser != null && filterPlantUser.length > 0) {
                        var index = 0;
                        for (index = 0; index < self.allplants.length; index++) {
                            self.plants.push(self.allplants[index]);
                        }
                        var filterPlant = [];
                        filterPlant = self.plants.filter((x) => x.plant == "Global");
                        if (filterPlant == null || filterPlant.length == 0) {
                            const globalPlant = {
                                id: 0,
                                plant: "Global",
                                otherInfo: "",
                                updatedBy: "",
                                updatedOn: new Date().toISOString(),
                            };
                            self.plants.push(globalPlant);
                        }
                    } else {
                        var index = 0;
                        for (index = 0; index < self.plantUsers.length; index++) {
                            var filterPlant = self.allplants.filter(
                                (x) => x.plant == self.plantUsers[index].plant
                            );
                            var checkPlantExists = self.plants.filter(
                                (x) => x.plant == self.plantUsers[index].plant
                            );
                            if (checkPlantExists.length == 0 && filterPlant.length > 0) {
                                self.plants.push(filterPlant[0]);
                            }
                        }
                    }
                })
                .catch((error) => console.log(error));
        },
        getUser() {
            var self = this;
            axios
                .get(window.apiurl + "/usercontext", {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.currentuser = response.data;
                    self.user = response.data;
                    const link4 =
                        window.apiurl +
                        "/userheadcount/myview/" +
                        self.currentuser.userEmail;
                    axios
                        .get(link4, {
                            withCredentials: true,
                            headers: self.requestHeaders
                        })
                        .then((response1) => {
                            self.useraccess = response1.data;
                            self.isPageLoading = false;
                            self.helperUserHCFromAPI();
                        })
                        .catch((error) => console.log(error));
                })
                .then(() => self.$store.commit("globalUser", self.currentuser))
                .catch((error) => console.log(error));
        },
        openNewUser() {
            var self = this;
            self.dialog = true;
            if (self.$store.state.allOADUsers != null) {
                self.OADUsers = self.$store.state.allOADUsers.resources;
                self.isAllOADUsersLoaded = true;
            } else {
                self.isAllOADUsersLoaded = false;
            }
        },
        close(isCancel) {
            this.dialog = false;
            this.isEditing = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                this.searchUser = "";
                this.addUserEmail = "";
                this.model = null;
                //this.emailreadOnly = false;
                this.selecttedplant = -1;
                this.selectedcontractor = -1;
                this.selectedlanguage = 1;
                this.isUserActive = "Y";
                this.isEditUser = false;
            });
            if (isCancel == 1) {
                this.$toast.clear();
            }
        },
        editItem(item) {
            this.isEditUser = true;
            this.editedIndex = this.users.indexOf(item);
            this.editedItem = Object.assign({}, item);
            //this.emailreadOnly = false;
            this.selecttedplant = this.plants.find(
                (x) => x.plant == this.editedItem.plant
            ).id;
            this.editedItem.previousPlant = this.editedItem.plant;
            this.changePlant(-1);
            this.selectedlanguage = this.languages.find(
                (x) => x.language == this.editedItem.language
            ).id;
            this.searchUser = this.editedItem.userName;
            this.addUserEmail = this.editedItem.userEmail;
            this.isUserActive = this.editedItem.isActive;
            this.dialog = true;
        },
        deleteItem(item) {
            this.editedIndex = this.users.indexOf(item);
            this.editedItem.id = item.id
            this.editedItem.plant = item.plant
            this.editedItem.company = item.company
            this.dialogDelete = true;
            this.deleteinProgress = false;
        },
        deleteItemConfirm() {
            this.isEditUser = false;
            this.deleteinProgress = true;
            var self = this;
            const deleteUser = {
                id: this.editedItem.id,
                plant: this.editedItem.plant,
                company: this.editedItem.company,
            };
            const link = window.apiurl + "/userheadcount/delete";
            axios
                .put(link, deleteUser, { withCredentials: true, headers: self.requestHeaders })
                .then(function (response) {
                    if (response.data.isSucess) {
                        //alert(response.data.messages[0].message);
                        self.$toast.clear();
                        self.$toast.success(self.$t("msgrecorddeleted"));
                        self.getUserHCFromAPI();
                    } else {
                        var index1 = 0;
                        for (
                            index1 = 0; index1 < response.data.messages.length; index1++
                        ) {
                            self.statusmessages.push(response.data.messages[index1]);
                        }
                        self.$toast.clear();
                        self.$toast.error(self.statusmessages[0]);
                    }
                    self.closeDelete()
                })
                .catch(function (err) {
                    console.log(err);
                });
        },
        closeDelete() {
            this.dialogDelete = false;
        },
        save() {
            if (
                this.selecttedplant == -1 ||
                this.selectedcontractor == -1 ||
                this.selectedlanguage == 0 ||
                (this.addUserEmail == null && this.isAllOADUsersLoaded) ||
                (this.model == null && !this.isAllOADUsersLoaded && !this.isEditUser) ||
                this.searchUser == null
            ) {
                this.$toast.error(this.$t("errfillrequiredfields"), {
                    timeout: false,
                });
            } else {
                this.editedItem.plant = this.plants.find(
                    (x) => x.id == this.selecttedplant
                ).plant;
                this.editedItem.company = this.companies.find(
                    (x) => x.id == this.selectedcontractor
                ).value;
                this.editedItem.language = this.selectedlanguage.toString();
                this.editedItem.createdBy = this.user.userEmail;
                if (this.isAllOADUsersLoaded) {
                    this.editedItem.userEmail = this.addUserEmail;
                    this.editedItem.userName = this.searchUser;
                } else if (this.model != null) {
                    this.editedItem.userEmail = this.model.email;
                    this.editedItem.userName = this.model.givenName;
                }
                this.editedItem.isActive = this.isUserActive;
                var object = null;
                if (this.editedIndex > -1) {
                    var self = this;
                    const link = window.apiurl + "/userheadcount/update";
                    axios
                        .put(link, this.editedItem, {
                            withCredentials: true,
                            headers: self.requestHeaders
                        })
                        .then((response) => {
                            if (response.data.isSucess) {
                                //alert(response.data.messages[0].message);
                                this.isEditUser = false;
                                self.$toast.clear();
                                self.$toast.success(self.$t("msguseredited"));
                                self.close();
                                self.searchUser = "";
                                self.getUserHCFromAPI();
                                //this.emailreadOnly = false;
                            }
                        })
                        .catch((error) => console.log(error));
                } else {
                    if (
                        this.users.find(
                            (x) =>
                            x.plant == this.editedItem.plant &&
                            x.company == this.editedItem.company &&
                            x.userEmail == this.editedItem.userEmail
                        ) != null
                    )
                        object = this.users.find(
                            (x) =>
                            x.plant == this.editedItem.plant &&
                            x.company == this.editedItem.company &&
                            x.userEmail == this.editedItem.userEmail
                        );
                    if (object == null) {
                        object = this.users.find(
                            (x) =>
                            x.plant == "Global" && x.userEmail == this.editedItem.userEmail
                        );
                        if (object == null) {
                            var self = this;
                            const link = window.apiurl + "/userheadcount/create";
                            axios
                                .post(link, this.editedItem, { withCredentials: true, headers: self.requestHeaders })
                                .then(function (response) {
                                    if (response.data.isSucess) {
                                        self.$toast.clear();
                                        self.$toast.success(self.$t("msguseradded"));
                                        self.close();
                                        self.searchUser = "";
                                        self.getUserHCFromAPI();
                                    } else {
                                        var index = 0;
                                        for (
                                            index = 0; index < response.data.messages.length; index++
                                        ) {
                                            self.statusmessages.push(response.data.messages[index]);
                                        }
                                          self.$toast.clear();
                                        self.$toast.error(self.statusmessages);
                                    }
                                })
                                .catch(function (err) {
                                    console.log(err);
                                });
                            this.close();
                        } else {
                            this.$toast.clear();
                            this.$toast.error(this.$t("errsameuserwithglobal"), {
                                timeout: false,
                            });
                        }
                    } else {
                        //alert("User already exists with same plant and company");
                        this.$toast.clear();
                        this.$toast.error(this.$t("errsamesuerwithplantcompany"), {
                            timeout: false,
                        });
                    }
                }
            }
        },
        selectedUser(value) {
            var self = this;
        },
        changePlant(selecetedObj) {
            if (selecetedObj == -1 && this.editedIndex > -1) {
                this.editedItem.previousCompany = this.editedItem.company;
                var companyLYBinPlant = null;
                if (
                    this.allcompanies.find(
                        (x) =>
                        x.value == this.editedItem.company &&
                        x.plant == this.editedItem.plant
                    ) != null
                )
                    companyLYBinPlant = this.allcompanies.find(
                        (x) =>
                        x.value == this.editedItem.company &&
                        x.plant == this.editedItem.plant
                    );
                if (companyLYBinPlant == null && this.editedItem.company == "LYB") {
                    const constLYB = {
                        id: 0,
                        plant: "Global",
                        value: "LYB",
                        otherInfo: "",
                        updatedBy: "",
                        updatedOn: new Date().toISOString(),
                    };
                    this.companies.push(constLYB);
                    this.selectedcontractor = 0;
                    this.companyreadOnly = true;
                } else {
                    var filterCompanies = [];
                    filterCompanies = this.allcompanies.filter(
                        (x) => x.plant.toLowerCase() == this.editedItem.plant.toLowerCase()
                    );
                    var index1 = 0;
                    for (index1 = 0; index1 < filterCompanies.length; index1++) {
                        this.companies.push(filterCompanies[index1]);
                    }
                    this.companyreadOnly = false;
                    var scarr = this.companies.find(
                        (x) => x.value == this.editedItem.company
                    );
                    if (scarr != undefined) {
                        this.selectedcontractor = scarr.id;
                    }
                }
            } else if (selecetedObj === parseInt(selecetedObj)) {
                var filterPlant = [];
                filterPlant = this.plants.filter((x) => x.id == selecetedObj);
                this.companies = [];
                if (filterPlant.length > 0 && filterPlant[0].plant == "Global") {
                    const constLYB = {
                        id: 0,
                        plant: "Global",
                        value: "LYB",
                        otherInfo: "",
                        updatedBy: "",
                        updatedOn: new Date().toISOString(),
                    };
                    this.companies.push(constLYB);
                    this.selectedcontractor = 0;
                    this.companyreadOnly = true;
                } else {
                    var filterCompanies = [];
                    filterCompanies = this.allcompanies.filter(
                        (x) => x.plant.toLowerCase() == filterPlant[0].plant.toLowerCase()
                    );
                    var index1 = 0;
                    for (index1 = 0; index1 < filterCompanies.length; index1++) {
                        this.companies.push(filterCompanies[index1]);
                    }
                    this.companyreadOnly = false;
                }
            }
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${month}/${day}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;

            const [month, day, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
        searchtest() {
            axios
                .get("https://api.publicapis.org/entries", {
                    withCredentials: true,
                })
                .then((res) => {
                    const { count, entries } = res;
                    this.count = count;
                    this.entries = entries;
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => (this.isLoading = false));
        },
        exportexcel() {
            //this.download = true
            this.JSONToCSVConvertor(this.users, "Users - Report", true);
        },
        JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
            //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
            var arrData =
                typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;

            var CSV = "";
            //Set Report title in first row or line

            CSV += ReportTitle + "\r\n\n";

            //This condition will generate the Label/Header
            if (ShowLabel) {
                var row = "";

                //This loop will extract the label from 1st index of on array
                for (var index in arrData[0]) {
                    //Now convert each value to string and comma-seprated
                    row += index + ",";
                }

                row = row.slice(0, -1);

                //append Label row with line break
                CSV += row + "\r\n";
            }

            //1st loop is to extract each row
            for (var i = 0; i < arrData.length; i++) {
                var row = "";

                //2nd loop will extract each column and convert it in string comma-seprated
                for (var index in arrData[i]) {
                    row += '"' + arrData[i][index] + '",';
                }

                row.slice(0, row.length - 1);

                //add a line break after each row
                CSV += row + "\r\n";
            }

            if (CSV == "") {
                //alert("Invalid data");
                self.$toast.clear();
                self.$toast.error(this.$t("errinvaliddata"), { timeout: false });
                return;
            }

            var filename = "UsersHeadcount.csv";
            var blob = new Blob([CSV], { type: "text/csv;charset=utf-8;" });
            if (navigator.msSaveBlob) {
                // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) {
                    // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style.visibility = "hidden";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        },
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? this.$t("newuser") : this.$t("edituser");
        },
        computedDateFormatted() {
            return this.formatDate(this.date);
        },
        hasAdminAccess() {
            var adminaccess = false;
            var filterUser = [];
            filterUser = this.useraccess.filter(
                (x) => x.plant == "Global" || x.company == "LYB"
            );
            if (filterUser != null && filterUser.length > 0) {
                adminaccess = true;
            }
            return adminaccess;
        },
        isLoggedInUserActive() {
            var isuseractive = false;
            if (this.useraccess.length > 0) {
                this.useraccess.forEach(function (elem, index) {
                    if (elem.isActive == "Y") {
                        isuseractive = true;
                    }
                });
            }
            return isuseractive;
        },
        rowsperpage() {
            return this.$t("rowsperpage");
        },
        fields() {
            if (!this.model) return [];

            return Object.keys(this.model).map((key) => {
                return {
                    key,
                    value: this.model[key] || "n/a",
                };
            });
        },
        items() {
            var self = this;
            return this.entries.map((entry) => {
                if (window.azuredeployed == 1) {
                    const givenName = entry.surname + ", " + entry.givenName;

                    return Object.assign({}, entry, { givenName });
                } else {
                    const givenName = entry.displayName;

                    return Object.assign({}, entry, { givenName });
                }
            });
        },
        headers() {
            return [{
                    text: this.$t("plant"),
                    align: "start",
                    value: "plant",
                },
                { text: this.$t("company"), value: "company" },
                { text: this.$t("username"), value: "userName" },
                { text: this.$t("language"), value: "language" },
                { text: this.$t("otherinfo"), value: "otherInfo" },
                { text: this.$t("isactive"), value: "isActive" },
                { text: this.$t("actions"), value: "action", sortable: false },
            ];
        },
    },
    watch: {
        dialog(val) {
            val || this.close();
        },
        date(val) {
            this.dateFormatted = this.formatDate(this.date);
        },
        searchapi(val) {
            // Items have already been loaded
            if (this.model) return;

            // Items have already been requested
            if (this.isLoading) return
            if (val != null && val.length > 2) {
                this.isLoading = true
                this.entries = []
                // Lazily load input items
                if (window.azuredeployed == 1) {
                    //if not IIS use Azure Graph Query
                    const link = window.apiurl + "/MyDirectory/users/find/" + val;
                    axios
                        .get(link, {
                            withCredentials: true,
                            headers: this.requestHeaders,
                        })
                        .then((res) => {
                            const {
                                itemsPerPage,
                                startIndex,
                                totalResults,
                                resources,
                            } = res.data;
                            //this.count = totalResults
                            this.entries = resources;
                        })
                        .catch((error) => {
                            console.log(error);
                        })
                        .finally(() => (this.isLoading = false));
                } else {
                    const link = window.apiurl + "/UserContext/ADUser/" + val; //For IIS use LDAP Query
                    axios
                        .get(link, {
                            withCredentials: true,
                            headers: this.requestHeaders,
                        })
                        .then((res) => {
                            //this.count = totalResults
                            this.entries = res.data;
                        })
                        .catch((error) => {
                            console.log(error);
                        })
                        .finally(() => (this.isLoading = false));
                }
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// ./src/components/User.vue